import styled from 'styled-components';
import determineProgressColor from './helpers';
import { Body } from '../../typography';
export const OuterBarContainer = styled.div `
  width: 100%;
  height: 8px;
  border-radius: 10px;
  background: ${({ theme }) => theme.progressBar.background};
`;
export const InnerBarContainer = styled.div `
  width: ${({ progress }) => (progress > 100 ? 100 : progress)}%;
  height: 8px;
  border-radius: 10px;
  background: ${({ progress, theme, warnWhenComplete }) => determineProgressColor(progress, theme, warnWhenComplete)};
`;
export const LegendWrapper = styled.div `
  display: flex;
  margin-top: 16px;
  justify-content: space-between;
`;
export const AmountDetailsContainer = styled.div `
  display: flex;
  flex-direction: column;
  &:last-child {
    text-align: end;
  }
`;
export const AmountContainer = styled(Body) `
  margin-bottom: 4px;
`;
